// import { roundValue, Unit } from "../Components/processors";
import { CategoryChart, isUnitDollar, Unit } from "../Components/processors";
import numeral from "numeral";
import {
    BILLING_ANNUAL_BILLING_BASED_ON_200KL,
    BILLING_ANNUAL_BILLING_BASED_ON_200KL_KPI_CODE,
    BILLING_ANNUAL_RESIDENTIAL_BILL,
    TYPICAL_ANNUAL_RESIDENT_BILL_KPI_CODE
} from "../Components/misc";
import { TableMethod } from "../Components/categoryChartQueryFns";

const _formatPattern = "0,0[.][00]";
const dollarFormatPatternWithTwoDecPlaces = "0,0.00";

export const formatNumber = (
    value: number,
    formatPattern = _formatPattern,
    unit?: Unit,
    categoryChart?: CategoryChart
): string => {
    if (value == null) return ``;

    if (
        isUnitDollar(unit) &&
        (categoryChart?.adminId?.toString()?.toLowerCase()?.indexOf("per-connection") > -1 ||
            categoryChart?.category?.adminId === BILLING_ANNUAL_RESIDENTIAL_BILL ||
            categoryChart?.category?.adminId === BILLING_ANNUAL_BILLING_BASED_ON_200KL)
    ) {
        return numeral(value).format(dollarFormatPatternWithTwoDecPlaces);
    }

    if (unit == null || unit?.toString()?.trim() === "") return numeral(value).format(formatPattern);

    return numeral(value).format(formatPattern);
};

export const formatTableColumnNumber = (
    metadata: {
        kpiCode: string;
        method: TableMethod;
        name: string;
        // schemeType: string;
    },
    value: number,
    unit?: Unit
): string => {
    if (value == null) return ``;

    if (
        metadata?.name?.toString()?.toLowerCase()?.indexOf("per connection") > -1 ||
        metadata?.method?.toString()?.toLowerCase()?.indexOf("perconnection") > -1 ||
        metadata?.kpiCode === TYPICAL_ANNUAL_RESIDENT_BILL_KPI_CODE ||
        metadata?.kpiCode === BILLING_ANNUAL_BILLING_BASED_ON_200KL_KPI_CODE
    )
        return numeral(value).format(dollarFormatPatternWithTwoDecPlaces);

    return formatNumber(value, undefined, unit);
};
